import { observer } from 'mobx-react';
import { FC, ReactElement, useEffect } from 'react';
import DashboardDetails from './containers/DashboardDetails/DashboardDetails';
import DashboardFilterTabs from './containers/DashboardFilterTabs/DashboardFilterTabs';
import DashboardPlates from './containers/DashboardPlates/DashboardPlates';
import DashboardSkeletons from './containers/DashboardSkeletons/DashboardSkeletons';
import { dashboardStore } from './store/dashboardStore';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import ScreenHeader from '~/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';

const DashboardScreen: FC = observer((): ReactElement => {
  useEffect(() => {
    dashboardStore.init();
  }, []);

  return (
    <div className="d-flex flex-column flex-grow-1">
      <ScreenHeader title="dashboard" options={[]} isBeta />
      <DashboardFilterTabs />

      <ScrollableBlock showScrollbar className="mr-4">
        {dashboardStore.isFirstLoading ? (
          <DashboardSkeletons />
        ) : (
          <div className="d-flex flex-column gap-30">
            <DashboardPlates />
            <DashboardDetails />
          </div>
        )}
      </ScrollableBlock>

      <LoadingOverlay visible={dashboardStore.isPlatesLoading} refreshing />
    </div>
  );
});

export default DashboardScreen;
